<template>
  <div class="m-auto justify-center z-30 fixed inset-x-0 inset-y-0 h-5/6 w-11/12 bg-white rounded-3xl hover:cursor-default font-text overflow-scroll text-default select-none">
    <div class="flex flex-col">
        <span class="text-default text-2xl my-1"> {{ title }} </span>
        <span v-if="title === 'Purdue University'" class="text-default text-xl my-1">Honors College</span>
        <span class="text-default text-xl my-1">{{ status }}</span>
      <div class="flex flex-row items-center">
        <div v-if="attachmentOne !== null" class="text-default hover:text-link mx-auto my-2 flex flex-row items-center">
          <Icon :icon="attachmentOne[2]"/>
          <a :href="attachmentOne[0]" class="mx-auto my-2 text-xl" target="_blank" rel="noopener noreferrer">&nbsp;<u>{{ attachmentOne[1] }}</u></a>
        </div>
        <div v-if="attachmentTwo !== null" class="text-default hover:text-link mx-auto my-2 flex flex-row items-center">
          <Icon class="text-default" :icon="attachmentTwo[2]" />
          <a class="mx-auto my-2 text-default text-xl" :href="attachmentTwo[0]" target="_blank" rel="noopener noreferrer">&nbsp;<u>{{ attachmentTwo[1] }}</u></a>
        </div>
      </div>
      <div class="items-center my-3">
        <div class="flex flex-col my-auto text-default mx-12 text-lg text-left" v-html="desc"></div>
      </div>
      <div class="h-full my-auto flex flex-col justify-center items-center content-center">
        <img :class="source[1]+' '+source[2]" class="my-4 image-holder" :key="index" v-for="(source, index) in this.images" :src="source[0]">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AchievementPopup',
  props: {
    title: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    attachmentOne: {
      type: Object,
      required: false
    },
    attachmentTwo: {
      type: Object,
      required: false
    },
    desc: {
      type: String,
      required: false
    },
    images: {
      type: Array,
      required: false
    }
  },
  created: function () {
    console.log(this.title)
    console.log(this.status)
    console.log(document.getElementsByTagName('body')[0].style.overflow = 'hidden')
  },
  unmounted: function () {
    console.log(document.getElementsByTagName('body')[0].style.overflow = 'auto')
  }
}
</script>
